import { lazy, Suspense, useContext } from 'react';
import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { ContentContext, useAnalytics } from '@parcel2go/npm-p2g-app';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';

const ManifestList = lazy(() => import('~/apps/smartsend/components/manifests/ManifestsList'));

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { track } = useAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  useOnLoad(() => {
    const title = t('MANIFESTS_PAGE_TITLE', { defaultValue: 'Manifests' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.SMARTSEND });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.Manifests, showSmartActions: true }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.Manifests
      }
    });
  });

  return (
    <Tagged tag="screen-manifests">
      <Suspense>
        <ManifestList isXs={isXs} />
      </Suspense>
    </Tagged>
  );
}

Component.displayName = 'SmartSend: Manifests';
